var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-editions",class:{
    'tw-py-6': true,
    'md:tw-flex md:tw--mx-4 md:tw-justify-center': true,
  }},_vm._l((_vm.cmsEditions),function(edition,key){return _c('cms-edition',{key:key,staticClass:"md:tw-flex-1 md:tw-mx-4 md:tw-max-w-xs",attrs:{"edition":edition}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }